export const EDIT_HEADER = 'Edit Class'
export const COURSE_INSTANCE_LABEL = 'Class Name'
export const COURSE_INSTANCE_PLACEHOLDER = 'Enter a class name'
export const EDIT_SUBMIT = 'Save Changes'
export const EDIT_CANCEL = 'Cancel'
